module.exports = require("dyna-error");